import { ColumnsSettingsViewDict, PageStatus, RegionId, ValidationErrorData } from './common';
import { GridRow } from './domain';
import { FilterPartialExpression } from './filter';
import { CurrencyCode, GdStatusApprove, GdViewType } from './graphql-grid';
import { TargetingTagValue } from './tagCloudTargeting';

export enum PriceGeoType {
    countries = 'countries',
    districts = 'districts',
    regions = 'regions'
}

export const GEO_TYPES = {
    3: PriceGeoType.countries,
    4: PriceGeoType.districts,
    5: PriceGeoType.regions
};

export const GEO_TYPES_API = {
    [PriceGeoType.countries]: 3,
    [PriceGeoType.districts]: 4,
    [PriceGeoType.regions]: 5
};

export interface PricePackageEditorValue {
    id: string;
    title: string;
    price: string;
    dateEnd: string;
    dateStart: string;
    orderVolumeMax: string;
    orderVolumeMin: string;
    currency: CurrencyCode;
    targetingsFixed: PricePackageTargetingsFixed;
    targetingsCustom: PricePackageTargetingsCustom;
}

export interface PricePackageEditorState {
    pricePackages: PricePackageEditorValue[];
}

export interface PricePackagesState {
    gridData: PricePackagesData;
    sourceParams: PricePackagesSourceParams;
    columnsSettings: ColumnsSettingsViewDict;
    selection: PricePackagesSelection;
    isSelectionEnabled: boolean;
}

export interface PricePackagesEditState {
    isNew: boolean;
    pageStatus: PageStatus;
    pricePackagesIds: PricePackageId[];
    errors: ValidationErrorData[];
    pricePackages: Record<PricePackageId, PricePackageEditData>;
}

export enum PricePackagesScreenUrlSearchParams {
    sortKey = 'sort-key',
    sortDirection = 'sort-direction',
    ulogin = 'ulogin',
    filter = 'filter',
    noStats = 'no-stats'
}
export enum PricePackagesEditScreenUrlSearchParams {
    pricePackagesIds = 'price-packages-ids',
    isNew = 'is-new',
    ulogin = 'ulogin'
}

export interface PricePackagesSourceParams {
    login: string;
    filter?: FilterPartialExpression[];
}

export interface PricePackagesMenuActions {
    onSendToApprove: (index: string) => void;
    onApprove: (index: string) => void;
    onReject: (index: string) => void;
    onEdit: (login: string, index: string) => void;
}

export interface PricePackageBaseFields extends GridRow {
    title: string;
    price: number;
    dateEnd: string;
    dateStart: string;
    orderVolumeMax: number;
    orderVolumeMin: number;
    currency: CurrencyCode;
    clientIds?: string[];
    statusApprove: GdStatusApprove;
    targetingsFixed: PricePackageTargetingsFixed;
    targetingsCustom: PricePackageTargetingsCustom;
    lastUpdateTime?: string;
}

export interface PricePackagesEditDataRegions {
    selectedMap: Record<RegionId, boolean>;
    regionIds: RegionId[];
    type?: PriceGeoType;
    isFixed?: boolean;
}

export interface PricePackageEditData extends PricePackageBaseFields {
    id: PricePackageId;
    trackerUrl: string;
    lastUpdateTime: string;
    regions: PricePackagesEditDataRegions;
    errors: Record<string, ValidationErrorData>;
}

export interface PricePackageRow extends PricePackageBaseFields, GridRow {}

export interface PricePackageTargetingsCustom {
    behaviors?: string[];
    geoType?: number;
    geo?: string[];
}

export interface PricePackageTargetingsFixed {
    viewTypes?: GdViewType[];
    geoType?: number;
    geo?: string[];
}

export interface PricePackagesData {
    data: Array<PricePackageRow>;
    allItemsIds: Array<string>;
    total: number;
}

export interface PricePackagesForGroup {
    id: PricePackageId;
    title: string;
    isFixedGeo: boolean;
}

export type PricePackageId = string;
export type PricePackagesSelection = PricePackageId[];
export type EditPricePackageErrorsRecord = Record<PricePackageId, Record<string, ValidationErrorData>>;

export interface PricePackagesClientsModalState {
    tags: TargetingTagValue[];
    isVisible: boolean;
    isProgress: boolean;
    title: string;
    id?: string;
    lastUpdateTime?: string;
    errors?: ValidationErrorData[];
}
